export default __webpack_public_path__ + "static/media/Sentinel-2.c8cce19e.jpg";